import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaDesdeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA DESDE' htmlFor='date-fechaDesde' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaDesde'>
          {({ field }) => (
            <Form.InputDate {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='date-fechaDesde' />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDesdeFormGroup)
